<script setup lang="ts">

</script>

<template>
  <!-- Modal -->
  <div class="modal fade" id="acquistaModal" tabindex="-1" aria-labelledby="acquistaModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body text-center">
          <h2>Diritto Civile</h2>
          <br>
          <h5>Il contenuto è disponibile<br>ma non è incluso nel tuo attuale piano</h5>
          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
        </div>
        <div class="modal-footer">
          <!-- button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button -->
          <button type="button" class="btn btn-error btn-lg w-100">CONTATTA L'AGENTE</button>
        </div>
      </div>
    </div>
  </div>

</template>
